import axios from "axios";
import graph from "../services/graph";


//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getCallendar(accessToken,selected_year,selected_month,groupId, selected_type,task_type) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/"+groupId, {
        params: {
          token: accessToken,
          selected_year : selected_year,
          selected_month : selected_month,
          selected_type,
          task_type
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonCalendar(accessToken,selected_year,selected_month,lawyer_id, selected_type, source_type) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/person-calendar/"+lawyer_id, {
        params: {
          token: accessToken,
          selected_year : selected_year,
          selected_month : selected_month,
          selected_type,
          source_type
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonCalendarList(accessToken,lawyer_id, selected_type, tab_name, start_date, end_date) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/person-calendar/"+lawyer_id+"/list", {
        params: {
          token: accessToken,
          selected_type,
          tab_name,
          start_date,
          end_date
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  printCalendar(html_page) {

    try {
      return axios({
        method: 'POST',
        url: "https://app-psod.cratis.cloud/predmeti/sharepoint/person-calendar/print",
        data : {
          html_page : html_page
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  getMiniCallendar(accessToken,selected_year,selected_month,groupId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/minicalendar/"+groupId, {
        params: {
          token: accessToken,
          selected_year : selected_year,
          selected_month : selected_month
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonMiniCalendar(accessToken,selected_year,selected_month,lawyer_id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/person-minicalendar/"+lawyer_id, {
        params: {
          token: accessToken,
          selected_year : selected_year,
          selected_month : selected_month
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonEvents(accessToken,lawyer_id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/person-events/"+lawyer_id, {
        params: {
          token: accessToken,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getRaspon(accessToken,start_date,end_date,groupId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/raspon/"+groupId, {
        params: {
          token: accessToken,
          start_date,
          end_date
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addEventToCalendar(formData) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/",formData, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addEventToPersonalCalendar(formData) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/sharepoint/personal-calendar", formData, {
        // params: {
        //   token: accessToken,
        //   event : event,
        //   person_uid: id
        // },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editEvent(formData) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/",formData, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editPersonalEvent(formData) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/sharepoint/personal-calendar",formData, {
        // params: {
        //   token: accessToken,
        //   event : event,
        // },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonalAttachment(accessToken,event_id,attachment_id){
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/personal-attachment", {
        params: {
          token: accessToken,
          event_id : event_id,
          attachment_id : attachment_id,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getEventType() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/event-type", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getEventBucketStatus() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/event-bucket-status", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editEventBucketStatus(event_id,event_type,status_val) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/event-bucket-status", {
        credentials: true,
        params:{
          event_id:event_id,
          event_type:event_type,
          current_val:status_val,
        }
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getImportanceTypes() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/event-importance", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getSingleEvent(id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/event/"+id, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteEvent(accessToken,event) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/sharepoint/calendar/event-delete", {
        credentials: true,
        params:{
          token: accessToken,
          event:event,
        }
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
}